export const getValidateUrl = (url: string, base?: string) => {
  if (!url) return null;
  try {
    return new URL(url, base);
  } catch {
    console.error(`${url} is not a valid url format`);
  }
  return null;
};
